import { getConfig } from '../config/configService';
import { FETCH } from '../components/Fetch/middleware';
import { verifyReturnUrl } from '../utils/verifyReturnUrl';

export const CHECKIN = '@TEXT2APPLY/CHECKIN';
export const NEXT = '@TEXT2APPLY/NEXT';
export const IDSCANREQUEST = '@TEXT2APPLY/IDSCANREQUEST';
export const UPLOADTOPRESIGNEDURLREQUEST = '@TEXT2APPLY/UPLOADTOPRESIGNEDURLREQUEST';
export const FETCH_EMAIL_TEMPELATE = '@TEXT2APPLY/FETCH_EMAIL_TEMPELATE';

// ID scan workflows
export const IDASTART = '@TEXT2APPLY/IDASTART';
export const IDANEXT = '@TEXT2APPLY/IDANEXT';
export const MANUAL_PAYMENT = '@TEXT2APPLY/MANUAL_PAYMENT';
export const NEW_MANUAL_PAYMENT = '@TEXT2APPLY/NEW_MANUAL_PAYMENT';
export const CHECK_PAYMENT = '@TEXT2APPLY/CHECK_PAYMENT';
export const GET_IP_ADDRESS = '@TEXT2APPLY/GET_IP_ADDRESS';
// VERIFICATON workflows
export const NEW_CHECKIN = '@TEXT2APPLY/NEW_CHECKIN';
export const NEW_START = '@TEXT2APPLY/NEW_START';
export const NEW_NEXT = '@TEXT2APPLY/NEW_NEXT';
export const RANDOM_NEXT = '@TEXT2APPLY/RANDOM_NEXT';
export const LAST_NEXT = '@TEXT2APPLY/LAST_NEXT';
export const NEW_CHECK_PAYMENT = '@TEXT2APPLY/NEW_CHECK_PAYMENT';
export const GET_DOCUMENT = '@TEXT2APPLY/GET_DOCUMENT';
export const OFFER_CHECKIN = '@TEXT2APPLY/OFFER_CHECKIN';
export const RESEND_OTP = '@TEXT2APPLY/RESEND_OTP';
export const SELECT_OFFER = '@TEXT2APPLY/SELECT_OFFER';
export const RESUME_APPLICATION = '@TEXT2APPLY/RESUME_APPLICATION';
export const VALIDATE_BANK_ROUTING_NUMBER = '@TEXT2APPLY/VALIDATE_BANK_ROUTING_NUMBER';

// t2a workflows
export const checkinAction = (payload) => {
  const config = getConfig();
  return {
    type: CHECKIN,
    [FETCH]: {
      method: 'PUT',
      url: payload.rawUrl
        ? payload.rawUrl
        : `${config.navigationUrl}/${payload.entityType}/${payload.entityId}/workflow/${payload.workflowType}/checkin`,
      onUploadProgress: payload.onUploadProgress,
      data: payload.data,
      success: (res) => { verifyReturnUrl(res, payload.success); },
      fail: payload.fail,
    },
  };
};

export const nextAction = (payload) => {
  const config = getConfig();
  return {
    type: NEXT,
    [FETCH]: {
      method: 'PUT',
      url: payload.rawUrl
        ? `${config.navigationUrl}${payload.rawUrl}`
        : `${config.navigationUrl}/${payload.entityType}/${payload.entityId}/workflow/${payload.workflowType}/next`,
      data: payload.data,
      onUploadProgress: payload.onUploadProgress,
      success: (res) => { verifyReturnUrl(res, payload.success); },
      fail: payload.fail,
      'Content-Encoding': 'gzip',
    },
  };
};

export const randomNextAction = (payload) => {
  const config = getConfig();
  return {
    type: RANDOM_NEXT,
    [FETCH]: {
      method: 'PUT',
      url: payload.rawUrl ? `${config.navigationUrl}${payload.rawUrl}` : `${config.navigationUrl}/${payload.entityType}/${payload.entityId}/workflow/${payload.workflowType}/next`,
      data: payload.data,
      onUploadProgress: payload.onUploadProgress,
      success: (res) => { verifyReturnUrl(res, payload.success); },
      fail: payload.fail,
      'Content-Encoding': 'gzip',
    },
  };
};

export const newRandomNextAction = (payload) => {
  const config = getConfig();
  return {
    type: RANDOM_NEXT,
    [FETCH]: {
      method: 'PUT',
      url: payload.rawUrl ? `${config.navigationUrl}${payload.rawUrl}` : `${config.navigationUrl}/${payload.workflowType}/${payload.key}/next`,
      data: payload.data,
      onUploadProgress: payload.onUploadProgress,
      success: (res) => { verifyReturnUrl(res, payload.success); },
      fail: payload.fail,
      'Content-Encoding': 'gzip',
    },
  };
};

export const lastNextAction = (payload) => {
  const config = getConfig();
  return {
    type: LAST_NEXT,
    [FETCH]: {
      method: 'PUT',
      url: payload.rawUrl ? `${config.navigationUrl}${payload.rawUrl}` : `${config.navigationUrl}/${payload.entityType}/${payload.entityId}/workflow/${payload.workflowType}/next`,
      data: payload.data,
      onUploadProgress: payload.onUploadProgress,
      success: payload.success,
      fail: payload.fail,
      'Content-Encoding': 'gzip',
    },
  };
};

export const offerCheckInAction = (payload) => {
  const config = getConfig();
  return {
    type: OFFER_CHECKIN,
    [FETCH]: {
      method: 'PUT',
      url: `${config.navigationUrl}/${payload.workflowType}/${payload.key}/checkin`,
      data: payload.data,
      onUploadProgress: payload.onUploadProgress,
      success: (res) => { verifyReturnUrl(res, payload.success); },
      fail: payload.fail,
      'Content-Encoding': 'gzip',
    },
  };
};

// new workflows
export const newCheckInAction = (payload) => {
  const config = getConfig();
  return {
    type: NEW_CHECKIN,
    [FETCH]: {
      method: 'PUT',
      url: payload.rawUrl
        ? payload.rawUrl
        : `${config.navigationUrl}/${payload.workflowType}/${payload.key}/checkin`,
      data: payload.data,
      onUploadProgress: payload.onUploadProgress,
      success: (res) => { verifyReturnUrl(res, payload.success); },
      fail: payload.fail,
    },
  };
};

export const newNextAction = (payload) => {
  const config = getConfig();
  return {
    type: NEW_NEXT,
    [FETCH]: {
      method: 'PUT',
      url: `${config.navigationUrl}/${payload.workflowType}/${payload.key}/next`,
      data: payload.data,
      onUploadProgress: payload.onUploadProgress,
      success: (res) => { verifyReturnUrl(res, payload.success); },
      fail: payload.fail,
      'Content-Encoding': 'gzip',
    },
  };
};

export const newEsignNextAction = (payload) => {
  const config = getConfig();
  return {
    type: NEW_NEXT,
    [FETCH]: {
      method: 'PUT',
      url: `${config.navigationUrl}/${payload.workflowType}/${payload.key}/next`,
      data: payload.data,
      onUploadProgress: payload.onUploadProgress,
      success: payload.success,
      fail: payload.fail,
      'Content-Encoding': 'gzip',
    },
  };
};

export const selectOfferAction = (payload) => {
  const config = getConfig();
  return {
    type: SELECT_OFFER,
    [FETCH]: {
      method: 'PUT',
      url: `${config.navigationUrl}/${payload.workflowType}/step/${payload.key}/SelectOffer/state`,
      data: payload.data,
      onUploadProgress: payload.onUploadProgress,
      success: (res) => { verifyReturnUrl(res, payload.success); },
      fail: payload.fail,
      'Content-Encoding': 'gzip',
    },
  };
};

export const newCheckPaymentAction = (payload) => {
  const config = getConfig();
  return {
    type: NEW_CHECK_PAYMENT,
    [FETCH]: {
      method: 'PUT',
      url: `${config.navigationUrl}/${payload.workflowType}/${payload.key}/step/PaymentCheck`,
      data: payload.data,
      onUploadProgress: payload.onUploadProgress,
      fail: payload.fail,
    },
  };
};

export const uploadImageToPreSignedUrlAction = (payload) => ({
  type: UPLOADTOPRESIGNEDURLREQUEST,
  [FETCH]: {
    method: 'PUT',
    url: payload.data.url,
    data: payload.data.imageData,
    headers: {
      'Content-Type': 'image/*',
    },
    onUploadProgress: payload.onUploadProgress,
    success: payload.success,
    fail: payload.fail,
  },
});

export const fetchEmailTempelateAction = (payload) => ({
  type: FETCH_EMAIL_TEMPELATE,
  [FETCH]: {
    method: 'POST',
    url: payload.data.url,
    data: payload.data.templateData,
    headers: {
      'Content-Type': 'application/json',
    },
    success: payload.success,
    fail: payload.fail,
    requireBlobData: payload.requireBlobData,
  },
});

export const idScanRequestAction = (payload) => {
  const config = getConfig();
  return {
    type: IDSCANREQUEST,
    [FETCH]: {
      method: 'POST',
      url: `${config.idScanUrl}/request/`,
      headers: {
        'Content-Type': 'application/json;charset=utf-8',
        Authorization: `Bearer ${config.idScanPubKey}`,
      },
      data: payload.data,
      onUploadProgress: payload.onUploadProgress,
      success: payload.success,
      fail: payload.fail,
    },
  };
};

export const idaStartAction = (payload) => {
  const config = getConfig();
  return {
    type: IDASTART,
    [FETCH]: {
      method: 'POST',
      url: `${config.navigationUrl}/${payload.entityType}/${payload.entityId}/workflow/${payload.workflowType}/start`,
      data: payload.data,
    },
  };
};

export const idaNextAction = (payload) => {
  const config = getConfig();
  return {
    type: IDANEXT,
    [FETCH]: {
      method: 'PUT',
      url: `${config.navigationUrl}/${payload.entityType}/${payload.entityId}/workflow/${payload.workflowType}/next`,
      data: payload.data,
    },
  };
};

export const newManualPaymentAction = (payload) => {
  const config = getConfig();
  return {
    type: NEW_MANUAL_PAYMENT,
    [FETCH]: {
      method: 'PUT',
      url: `${config.navigationUrl}/${payload.workflowType}/${payload.key}/step/PaymentManual`,
      data: payload.data,
      onUploadProgress: payload.onUploadProgress,
    },
  };
};

export const checkPaymentAction = (payload) => {
  const config = getConfig();
  return {
    type: CHECK_PAYMENT,
    [FETCH]: {
      method: 'PUT',
      url: `${config.navigationUrl}/${payload.entityType}/${payload.entityId}/workflow/${payload.workflowType}/step/PaymentCheck`,
      data: payload.data,
      onUploadProgress: payload.onUploadProgress,
    },
  };
};

export const getIPAddress = (payload) => ({
  type: GET_IP_ADDRESS,
  [FETCH]: {
    method: 'GET',
    url: 'https://api.ipify.org?format=json&callback=?',
    success: payload.success,
  },
});

export const getDocument = (payload) => ({
  type: GET_DOCUMENT,
  [FETCH]: {
    method: 'GET',
    url: payload.url,
    success: payload.success,
  },
});

export const resendOTPText = (payload) => {
  const config = getConfig();
  return {
    type: RESEND_OTP,
    [FETCH]: {
      method: 'POST',
      url: `${config.navigationUrl}/${payload.workflowType}/${payload.key}/otp/resend`,
      success: payload.success,
      fail: payload.fail,
      data: payload.data,
    },
  };
};

export const resumeApplication = (payload) => {
  const config = getConfig();
  return {
    type: RESUME_APPLICATION,
    [FETCH]: {
      method: 'PUT',
      url: `${config.navigationUrl}/${payload.workflowType}/${payload.key}/continuefromcreditfreeze/resume`,
      success: payload.success,
      fail: payload.fail,
      data: payload.data,
    },
  };
};

export const validateBankRoutingNumberAction = (payload) => {
  const config = getConfig();
  return {
    type: VALIDATE_BANK_ROUTING_NUMBER,
    [FETCH]: {
      method: 'GET',
      url: `${config.navigationUrl}/helpers/bank-account/routing-number/${payload.routingNumber}`,
      success: payload.success,
      fail: payload.fail,
    },
  };
};
